import type { BadgeAward, BadgeDefinition } from '@/domain/badge'
import type { BadgeRepository } from '@/repositories/BadgeRepository'
import { seedBadgeDefinitions } from '@/data/seed/badges'

const STORAGE_KEY = 'cybertales.badgeAwards'

function readAll(): BadgeAward[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as BadgeAward[]) : []
  } catch {
    return []
  }
}

function writeAll(items: BadgeAward[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch {
    // best-effort — badge awards simply won't persist across reloads.
  }
}

// Zero-cost implementation of BadgeRepository (Document 11 §4). award() is
// idempotent on (userId, badgeKey) — matches the unique index specified in
// Document 5 §8, enforced here in application code instead of a DB constraint.
export class LocalBadgeRepository implements BadgeRepository {
  async listDefinitions(): Promise<BadgeDefinition[]> {
    return seedBadgeDefinitions
  }

  async listAwardsForUser(userId: string): Promise<BadgeAward[]> {
    return readAll().filter((a) => a.userId === userId)
  }

  async award(award: BadgeAward): Promise<void> {
    const all = readAll()
    const alreadyAwarded = all.some((a) => a.userId === award.userId && a.badgeKey === award.badgeKey)
    if (alreadyAwarded) return
    all.push(award)
    writeAll(all)
  }
}
